// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"2f82f8b6","248":"7c9e7ee0","597":"ad85ffa7","962":"f337cd5e"}[chunkId] + ".chunk.css";
};